import APP_ACTIONS from '../constants/app-actions';

const countries = {
    addBillingCountries: (countriesResponse) => ({
        type: APP_ACTIONS.ADD_COUNTRIES_BILLING,
        payload: countriesResponse,
    }),
    addShippingCountries: (countriesResponse) => ({
        type: APP_ACTIONS.ADD_COUNTRIES_SHIPPING,
        payload: countriesResponse,
    }),
};

export default countries;



/** WEBPACK FOOTER **
 ** ./src/actions/countries.js
 **/